import { RootState } from '@/store';
import { createSelector } from '@reduxjs/toolkit';

export const selectDV360TicketsCreativesData = (state: RootState) => state.dv360TicketsCreatives;

export const selectDV360TicketsCreatives = createSelector(
  [selectDV360TicketsCreativesData],
  ({ creatives, creativesRequestId, total }) => ({
    loading: !!creativesRequestId,
    creatives,
    total,
  }),
);

export const selectDV360TicketsCreativesFilters = createSelector(
  [selectDV360TicketsCreativesData],
  ({ filters }) => filters,
);
